import { ClearContactsAndCounts } from '@/store/contacts/actions';
import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { ContactTableContext } from '../components/ContactListTable/context';
import { useContactQueryParams } from './useContactQueryParams';
import { useContactReload } from './useContactReload';
import { useEntityRuleForFiltration } from './useFiltrationRule';

export const useFetchContactsBasedOnUrl = () => {
    const dispatch = useDispatch();

    const { clearSelectedRows } = useContext(ContactTableContext);

    const { querySearch, queryOrderBy, queryStatuses, queryPage, queryPerPage } = useContactQueryParams();
    const { entityRule, isAllContactsSegment } = useEntityRuleForFiltration();
    const { reloadContactsBasedOnQuery } = useContactReload();

    useEffect(() => {
        clearSelectedRows?.();
        //fail safe to not launch contacts fetch if there is no rule for list or segment
        if (!entityRule && !isAllContactsSegment) {
            return;
        }
        reloadContactsBasedOnQuery();

        dispatch(ClearContactsAndCounts());
    }, [queryPage, queryStatuses?.toString(), querySearch, queryOrderBy, entityRule, queryPerPage]);
};
